import Product from "components/common/product-thumb"
import Products from "components/common/products"

export default ({selection, loading}) => {
	return (
		<section>
			{ selection.products.items.length > 0
				? <Products products={selection.products.items} loading={loading}>
						{products => {
							const selectionProducts = products.filter(p => p.available)
							if (selectionProducts.length == 0) return null
							return (
								<ul className="grid films">
									{ selectionProducts.map(product => (
											<Product product={product} loading={loading} />
									))}
								</ul>
							)
						}}
					</Products>
				: null
			}
			{ selection.children.items.map((category, index) => {
					if (category.products.items.length == 0) return null

					return (
						<Products key={`product-${index}`} products={category.products.items} loading={loading}>
							{ products => {
								const selectionProducts = products.filter(p => p.available)
								if (selectionProducts.length == 0) return null

								return (
									<>
										<h3 className="section-title">{category.name}</h3>
										<ul className="grid films">
											{ selectionProducts.map(product => (
												<Product product={product} loading={loading} />
											))}
										</ul>
									</>
								)
							}}
						</Products>
					)
			})}
		</section>
	)
}
